import { Keys } from '../helpers/Keys';

export interface IPopupMenuScope extends ng.IScope {
  direction: string;
  disabled: boolean;
  opened: (locals: any) => any;
  closed: () => any;
  popupMenu: PopupMenuCtrl;
}

export class PopupMenuCtrl {

  public static $inject = [
    '$element',
    '$scope'
  ];

  private scope: IPopupMenuScope;
  private _open: boolean;
  private button: JQuery;
  private content: ng.ITranscludeFunction;

  public contentWidth: number;
  public contentMatchButtonWidth = false;
  public autoExpand = false;

  constructor(
    private $element: JQuery,
            $scope: IPopupMenuScope) {
    this._open = false;
    this.scope = $scope;
    this.scope.popupMenu = this;
  }

  public getButton = () => {
    return this.button;
  }

  public setButton(button: JQuery) {
    this.button = button;
  }

  public getButtonWidth() {
    return this.button.outerWidth();
  }

  public setContent(content: ng.ITranscludeFunction) {
    this.content = content;
  }

  public getContent(): ng.ITranscludeFunction {
    return this.content;
  }

  public getContentScope() {
    return {
      popupMenu: {
        button: this.button,
        close: () => this.close()
      }
    };
  }

  public isUp(): boolean {
    switch (this.scope.direction) {
      case 'dr':
      case 'dl':
      default:
        return false;
      case 'ur':
      case 'ul':
        return true;
    }
  }

  public positionCorner(): string {
    switch (this.scope.direction) {
      case 'dr':
      default:
        return 'bl';
      case 'dl':
        return 'br';
      case 'ur':
        return 'tl';
      case 'ul':
        return 'tr';
    }
  }

  public contentCorner(): string {
    switch (this.scope.direction) {
      case 'dr':
      default:
        return 'tl';
      case 'dl':
        return 'tr';
      case 'ur':
        return 'bl';
      case 'ul':
        return 'br';
    }
  }

  public isDisabled() {
    // If disabled is undefined, then default to enabled.
    return this.scope.disabled === true;
  }

  public isOpen() {
    return this._open;
  }

  public keydown($event: JQueryKeyEventObject) {

    if (this.isDisabled()) {
      return;
    }

    switch($event.which) {

      case Keys.Enter:
        this.toggle();
        $event.stopPropagation(); // Prevents Enter from closing containing dialog (if any)
        break;

      case Keys.Space:
        if (!this._open) {
          this.open();
        }
        break;
    }
  }

  public toggle() {
    if (!this.isDisabled()) {
      if (this._open) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  public open() {
    this._open = true;
    this.contentWidth = this.contentMatchButtonWidth ? this.getButtonWidth() : null;
    this.scope.opened({ closeFn: angular.bind(this, this.close) });
  }

  /*
  focusElement - the JQuery element to focus on after this popup has closed.
  Default is the button used to open the popup.
  */
  public close(focusElement: JQuery = this.$element) {
    this._open = false;
    this.scope.closed();
    focusElement.focus();
  }

  public mousedownOutside(downEvent: JQueryMouseEventObject) {
    const target = $(downEvent.target);
    if (target.closest(this.button).length === 0) {
      this.close(target); //focus should be placed wherever the user clicks.
    }
  }

}
